// extracted by mini-css-extract-plugin
export default {"todoFormContainer":"TodoForm_todoFormContainer__KXQYF"};